// REACT & REDUX
import { connect } from "react-redux";

// STYLE, PROPS & TRANSLATIONS

// COMMON

// COMPONENTS
import { Root } from "./Root.component";

// CONTAINERS

// ACTIONS & API

// *************************************************************************************************************************************

const mapStateToProps = state => {
    return {};
};

export default connect(mapStateToProps)(Root);
